import React, { PureComponent } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Row, Col, Checkbox, Popover, Tag } from 'antd';
import RegionsView from './RegionsView';
import { getRegions } from '../../helpers/getRegions';
class RegionSelector extends PureComponent {
  state = {
    popVisible: false,
    selectedRegions: [],
  };

  handlePopOver = v => {
    this.setState({
      popVisible: v,
    });
  };
  resetRegions = () => {
    this.props.selectedRegions([]);
    this.setState({
      selectedRegions: [],
    });
  };

  selectedRegions = params => {
    this.props.selectedRegions(params);
    this.setState({
      selectedRegions: params,
      popVisible: false,
    });
    this.handlePopOver(true);
  };
  componentDidMount() {
    this.setState({
      selectedRegions: this.props?.checkedRegions,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedCloud !== this.props.selectedCloud) {
      this.resetRegions();
    }
  }

  render() {
    const { selectedCloud, checkedRegions } = this.props;
    return (
      <div>
        <Popover
          // className={styles.antpopover}
          placement="top"
          onVisibleChange={this.handlePopOver}
          content={
            <RegionsView
              selectedCloud={selectedCloud}
              regions={getRegions(selectedCloud)}
              selectedRegions={this.selectedRegions}
              checkedRegions={checkedRegions}
              resetRegions={this.resetRegions}
            />
          }
          trigger="click"
          visible={this.state.popVisible}
        >
          <div
            id="RegionSelector"
            style={{
              border: '1px solid #D9D9D9',
              height: '32px',
              minWidth: '30px',
              marginTop: '3px',
              borderRadius: '4px',
              // overflow: 'hidden',
            }}
          >
            {this.state.selectedRegions.length === 0 ? (
              <div style={{ marginLeft: '11px', marginTop: '-4px', color: '#CAC2C4' }}>
                Please select...
              </div>
            ) : (
              <div
                style={{
                  marginTop: '-15px',
                }}
              >
                {this.state.selectedRegions.map((v, i) => {
                  if (i >= 4) {
                    return;
                  }
                  return (
                    <Tag
                      key={i}
                      style={{
                        marginRight: '2px',
                        marginTop: '21px',
                        marginLeft: '5px',
                        border: 0,
                        background: '#d9d9d99c',
                        // position: 'unset',
                      }}
                    >
                      {v.length > 6 ? v.substring(0, 6).concat('...') : v}
                    </Tag>
                  );
                })}
              </div>
            )}

            {
              <DownOutlined
                style={{
                  float: 'right',
                  marginRight: '6px',
                  marginLeft: '5px',
                  fontSize: '13px',
                  marginTop: '-27px',
                }}
              />
            }
          </div>
        </Popover>
      </div>
    );
  }
}
export default RegionSelector;
